import { type FC, type ReactNode } from "react";
import { cn } from "@/shared/lib/utils";
import { MobileNavHeader } from "./MobileNavHeader";

type Props = {
  header?: ReactNode;
  actions?: ReactNode;
  hidden?: boolean;
};

export const MainTopNav: FC<Props> = ({ header, actions, hidden }) => {
  if (hidden) {
    return null;
  }

  return (
    <header className="sticky top-0 z-20 bg-white border-b border-primary">
      <div
        className={cn(
          "flex px-4 md:px-10 py-4 items-center gap-4 self-stretch justify-between",
          !header && "lg:justify-end",
        )}
      >
        <MobileNavHeader />
        {header && <p className="hidden lg:block flex-1 text-base font-semibold">{header}</p>}
        {actions && <div className="flex items-center gap-2 lg:gap-4">{actions}</div>}
      </div>
    </header>
  );
};
